import { render, staticRenderFns } from "./Tagst.vue?vue&type=template&id=ee3f8a6e&scoped=true&"
import script from "./Tagst.vue?vue&type=script&lang=js&"
export * from "./Tagst.vue?vue&type=script&lang=js&"
import style0 from "./Tagst.vue?vue&type=style&index=0&id=ee3f8a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3f8a6e",
  null
  
)

export default component.exports